import type { ReactText } from 'react';
import { useState, useEffect } from 'react';

import type { TFormAction } from '../models';
import { RECIPIENT_HOST, RECIPIENT_URL } from '../config';

export type TFormActionElement = (() => ReactText | undefined) | ReactText | undefined;

const processActionText = (action: TFormActionElement) =>
    typeof action === 'function' ? action() : action;

/** Из объекта сооружает URL c query-string из валидных значений */
export const getFormAction = (actions: Record<string, TFormActionElement>, actionPath?: string) => {
    const url = actionPath ? `${RECIPIENT_HOST}${actionPath}` : RECIPIENT_URL;

    const actionsResult = Object.keys(actions)
        .map(key => ({ key, value: processActionText(actions[key]) }))
        .filter(({ value }) => value || value === 0)
        .map(({ key, value }) => `${key}=${value}`)
        .join('&');

    return `${url}${actionsResult}`;
};

export const useActions = (actions: Record<string, TFormActionElement>, actionPath?: string) => {
    const [action, setAction] = useState('');
    /**
     * Объект с изначальными ключами и значениями action поля формы,
     * значение может быть функцией, возвращающей финальное значение
     */
    const [formAction, setFormAction] = useState(actions);

    // Обновляет action после рендера и при изменении объекта formAction
    useEffect(() => setAction(getFormAction(formAction, actionPath)), [actionPath, formAction]);

    return [
        action,
        ([values]: [TFormAction]) => setFormAction(prevAction => ({ ...prevAction, ...values })),
    ] as const;
};
